<template>
  <v-row no-gutters justify="center">
    <main-loader v-if="loading" />
    <v-col :cols="cols" v-else>
      <canvas :id="`chart-${name}`"></canvas>
    </v-col>
  </v-row>
</template>
<script>
import { debounce } from 'lodash';
import Chart from 'chart.js';
import MainLoader from '@/components/MainLoader';
export default {
  name: 'ChartLine',
  components: { MainLoader },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    labels: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'chart',
    },
    cols: {
      type: [Number, String],
      default: '10',
    },
  },
  data: () => ({
    chart: undefined,
  }),
  methods: {
    downloadChart() {
      this.$_saveFile(this.chart.toBase64Image(), this.$i18n.t('dialog.body.chart'));
    },
    drawChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      if (this.labels.length < 1 && this.data.length < 1) {
        return;
      }
      Chart.plugins.register({
        afterRender: function(c) {
          const ctx = c.chart.ctx;
          ctx.save();
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, c.chart.width, c.chart.height);
          ctx.restore();
        },
      });
      const canvas = document.getElementById(`chart-${this.name}`);
      this.chart = new Chart(canvas, {
        options: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false,
          },
          elements: {
            point: {
              radius: 3,
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  autoSkip: true,
                  stepSize: 20,
                },
                scaleLabel: {
                  display: true,
                  labelString: '',
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  autoSkip: true,
                },
              },
            ],
          },
        },
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.data,
              fill: false,
              lineTension: 0,
              borderColor: '#2a579a',
              backgroundColor: '#2a579a',
            },
          ],
        },
      });
    },
  },
  mounted() {
    this.$watch(
      vm => [vm.data, vm.labels],
      () => {
        this.drawChart();
      }
    );
    this.drawChart();
  },
  created() {
    this.drawChart = debounce(this.drawChart, 500);
  },
};
</script>
